





















































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import DataAsesmenDentalKhusus from "@/services/DataAsesmenDentalKhusus";
import {
  AsesmenDentalKhusus,
  FotoKategori,
  FotoKlinis,
  Interpretasi,
  OhisData,
  OHIS_SENTINEL_TEETH,
  OHIS_TOOTH_LABEL,
  OHIS_ALT,
  INTRAORAL_VIEWS,
  EKSTRAORAL_VIEWS,
  PERAWATAN_VIEWS,
  LAINNYA_VIEWS,
  emptyOhisData,
  recomputeOhis
} from "@/types/asesmen_dental_khusus";

interface LocalForm {
  tgl_periksa: string;
  dokter: { id: number; nama: string } | null;
  ohis: OhisData;
  di_s: number | null;
  ci_s: number | null;
  ohis_total: number | null;
  interpretasi: Interpretasi;
  catatan: string | null;
}

@Component({
  components: { DokterAutoComplete },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardAsesmenDentalKhusus extends Vue {
  @Prop({ required: true }) register!: string;
  @Prop({ required: true }) rm!: string;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  ohisTeeth = OHIS_SENTINEL_TEETH;

  valid = true;
  saving = false;
  uploading = false;
  menuTgl = false;
  previewDialog = false;
  previewItem: FotoKlinis | null = null;
  maxDate = localISODate();

  data: AsesmenDentalKhusus | null = null;

  form: LocalForm = {
    tgl_periksa: this.maxDate,
    dokter: null,
    ohis: emptyOhisData(),
    di_s: null,
    ci_s: null,
    ohis_total: null,
    interpretasi: null,
    catatan: null
  };

  upload: {
    kategori: FotoKategori;
    view: string;
    catatan: string;
    file: File | null;
  } = {
    kategori: "intraoral",
    view: "",
    catatan: "",
    file: null
  };

  mounted() {
    this.loadData();
    this.prefillDokter();
  }

  @Watch("register")
  onRegisterChange(v: string) {
    if (v) {
      this.loadData();
    }
  }

  prefillDokter() {
    const u = userModule.user as any;
    if (u && u.id && !this.form.dokter) {
      this.form.dokter = { id: Number(u.id), nama: u.nama || u.name || "" };
    }
  }

  async loadData() {
    if (!this.register) return;
    const res = await DataAsesmenDentalKhusus.getByRegister(
      String(this.register)
    );
    if (res) {
      this.data = res;
      const ohis: OhisData = emptyOhisData();
      const rawOhis = (res.ohis || {}) as any;
      for (const k of OHIS_SENTINEL_TEETH) {
        if (rawOhis[k]) {
          ohis[k] = {
            tooth_used: rawOhis[k].tooth_used || k,
            examined: !!rawOhis[k].examined,
            debris:
              rawOhis[k].debris == null ? null : Number(rawOhis[k].debris),
            calculus:
              rawOhis[k].calculus == null ? null : Number(rawOhis[k].calculus),
            alasan_excluded: rawOhis[k].alasan_excluded ?? null
          };
        }
      }
      this.form = {
        tgl_periksa: res.tgl_periksa || this.maxDate,
        dokter: res.dokter,
        ohis,
        di_s: res.di_s,
        ci_s: res.ci_s,
        ohis_total: res.ohis_total,
        interpretasi: res.interpretasi,
        catatan: res.catatan
      };
      this.recompute();
    } else {
      this.data = null;
    }
  }

  // ============ Computeds ============

  get fotos(): FotoKlinis[] {
    return this.data?.fotos ?? [];
  }

  get totalFotos(): number {
    return this.fotos.length;
  }

  get viewOptions() {
    if (this.upload.kategori === "intraoral") return INTRAORAL_VIEWS;
    if (this.upload.kategori === "ekstraoral") return EKSTRAORAL_VIEWS;
    if (this.upload.kategori === "perawatan") return PERAWATAN_VIEWS;
    return LAINNYA_VIEWS;
  }

  get canUpload(): boolean {
    if (this.readOnly) return false;
    return !!this.upload.file && !this.uploading;
  }

  get interpColor(): string {
    switch (this.form.interpretasi) {
      case "baik":
        return "green darken-1";
      case "sedang":
        return "amber darken-2";
      case "buruk":
        return "red darken-2";
      default:
        return "grey";
    }
  }

  get interpLabel(): string {
    switch (this.form.interpretasi) {
      case "baik":
        return "BAIK";
      case "sedang":
        return "SEDANG";
      case "buruk":
        return "BURUK";
      default:
        return "Belum dihitung";
    }
  }

  get interpRange(): string {
    switch (this.form.interpretasi) {
      case "baik":
        return "0.0 – 1.2";
      case "sedang":
        return "1.3 – 3.0";
      case "buruk":
        return "3.1 – 6.0";
      default:
        return "—";
    }
  }

  // ============ Helpers ============

  ohisLabel(k: string) {
    return OHIS_TOOTH_LABEL[k as keyof typeof OHIS_TOOTH_LABEL];
  }

  ohisAlt(k: string): string[] {
    return OHIS_ALT[k as keyof typeof OHIS_ALT] || [];
  }

  formatView(v: string): string {
    const found =
      INTRAORAL_VIEWS.find(x => x.value === v) ||
      EKSTRAORAL_VIEWS.find(x => x.value === v) ||
      PERAWATAN_VIEWS.find(x => x.value === v) ||
      LAINNYA_VIEWS.find(x => x.value === v);
    return found ? found.label : v;
  }

  onKategoriChange() {
    // Reset pilihan view agar tidak memakai view dari kategori sebelumnya
    this.upload.view = "";
  }

  setDokter(val) {
    this.form.dokter = val;
  }

  recompute() {
    const c = recomputeOhis(this.form.ohis);
    this.form.di_s = c.di_s;
    this.form.ci_s = c.ci_s;
    this.form.ohis_total = c.ohis_total;
    this.form.interpretasi = c.interpretasi;
  }

  onExaminedChange(k: string) {
    const t = this.form.ohis[k as keyof OhisData];
    if (!t.examined) {
      t.debris = null;
      t.calculus = null;
    } else {
      t.alasan_excluded = null;
      if (!t.tooth_used) t.tooth_used = k;
    }
    this.recompute();
  }

  // ============ Save ============

  async onSave() {
    if (this.readOnly) return;
    const formRef = this.$refs.form as Vue & { validate: () => boolean };
    if (!formRef.validate()) {
      appModule.NoticeDelayAlert("Lengkapi kolom yang wajib diisi");
      return;
    }
    if (!this.form.dokter?.id) {
      appModule.NoticeDelayAlert("Dokter pemeriksa belum dipilih");
      return;
    }
    const u: any = userModule.user;
    if (!u?.id) {
      appModule.NoticeDelayAlert(
        "Sesi user tidak ditemukan, mohon login ulang"
      );
      return;
    }

    this.saving = true;
    appModule.setLoading(true);

    const payload = {
      register_id: String(this.register),
      pasien_rm: this.rm,
      tgl_periksa: this.form.tgl_periksa,
      ohis: this.form.ohis,
      catatan: this.form.catatan,
      dokter_id: Number(this.form.dokter.id),
      user_id: Number(u.id)
    };

    const res = this.data?.id
      ? await DataAsesmenDentalKhusus.update(this.data.id, payload)
      : await DataAsesmenDentalKhusus.save(payload);

    appModule.setLoading(false);
    this.saving = false;

    if (res) {
      this.data = res;
      appModule.NoticeDelay(
        this.data?.id
          ? "Asesmen Dental Khusus tersimpan"
          : "Asesmen Dental Khusus dibuat"
      );
      await this.loadData();
    }
  }

  openPdf() {
    if (!this.data?.id) return;
    window.open(DataAsesmenDentalKhusus.pdfUrl(this.data.id), "_blank");
  }

  // ============ Foto ============

  onFileChosen(f: File | null) {
    if (f && f.size > 10 * 1024 * 1024) {
      appModule.NoticeDelayAlert("Ukuran file melebihi 10MB");
      this.upload.file = null;
    }
  }

  async onUpload() {
    if (this.readOnly) return;
    if (!this.canUpload || !this.data?.id || !this.upload.file) return;
    this.uploading = true;
    const res = await DataAsesmenDentalKhusus.uploadFoto(
      this.data.id,
      this.upload.file,
      {
        kategori: this.upload.kategori,
        view: this.upload.view || undefined,
        catatan: this.upload.catatan || undefined
      }
    );
    this.uploading = false;
    if (res) {
      if (this.data) {
        this.data.fotos = [...this.data.fotos, res];
      }
      this.upload.file = null;
      this.upload.catatan = "";
      this.upload.view = "";
      appModule.NoticeDelay("Foto berhasil diunggah");
    }
  }

  async onDeleteFoto(f: FotoKlinis) {
    if (this.readOnly) return;
    if (!this.data?.id) return;
    const ok = window.confirm("Hapus foto ini?");
    if (!ok) return;
    const success = await DataAsesmenDentalKhusus.deleteFoto(
      this.data.id,
      f.id
    );
    if (success && this.data) {
      this.data.fotos = this.data.fotos.filter(x => x.id !== f.id);
      appModule.NoticeDelay("Foto dihapus");
    }
  }

  previewFoto(f: FotoKlinis) {
    this.previewItem = f;
    this.previewDialog = true;
  }
}
